import { render } from "./CouponEdit.vue?vue&type=template&id=7887f2f7"
import script from "./CouponEdit.vue?vue&type=script&lang=js"
export * from "./CouponEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__